import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnounce = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_5583_50499)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.833 3.95052V6.66635C16.1613 6.66635 16.4864 6.73102 16.7897 6.85665C17.093 6.98229 17.3686 7.16644 17.6008 7.39859C17.8329 7.63073 18.0171 7.90633 18.1427 8.20965C18.2683 8.51296 18.333 8.83805 18.333 9.16635C18.333 9.49466 18.2683 9.81975 18.1427 10.1231C18.0171 10.4264 17.8329 10.702 17.6008 10.9341C17.3686 11.1663 17.093 11.3504 16.7897 11.4761C16.4864 11.6017 16.1613 11.6664 15.833 11.6664V14.1664C15.833 15.5397 14.2655 16.3239 13.1663 15.4997L11.4497 14.2114C10.532 13.5233 9.46362 13.064 8.33299 12.8714V15.2414C8.33308 15.7861 8.13624 16.3126 7.77874 16.7237C7.42124 17.1348 6.9272 17.4028 6.38767 17.4783C5.84814 17.5538 5.29951 17.4317 4.84289 17.1346C4.38628 16.8374 4.05246 16.3852 3.90299 15.8614L2.59466 11.2814C2.12384 10.7253 1.81744 10.049 1.7099 9.32844C1.60235 8.60785 1.69794 7.87155 1.98589 7.2023C2.27385 6.53305 2.74278 5.95739 3.33995 5.54002C3.93712 5.12265 4.63888 4.88012 5.36632 4.83969L7.88132 4.69969C9.11184 4.63121 10.3085 4.27163 11.373 3.65052L13.3263 2.51052C14.438 1.86302 15.833 2.66385 15.833 3.95052ZM4.69466 12.5647L5.50549 15.4039C5.54451 15.5413 5.63194 15.66 5.75164 15.738C5.87133 15.8159 6.0152 15.848 6.15668 15.8282C6.29817 15.8084 6.42771 15.7381 6.52138 15.6302C6.61506 15.5223 6.66654 15.3842 6.66632 15.2414V12.733L5.36632 12.6605C5.14009 12.648 4.91537 12.6159 4.69466 12.5647ZM14.1663 3.95052L12.2122 5.09135C11.025 5.78339 9.70117 6.20826 8.33299 6.33635V11.1855C9.82216 11.3905 11.2397 11.9714 12.4497 12.878L14.1663 14.1664V3.95052ZM6.66632 6.43635L5.45799 6.50302C4.89586 6.53406 4.36579 6.7747 3.97242 7.17745C3.57905 7.58021 3.35095 8.11579 3.33316 8.6785C3.31537 9.2412 3.50918 9.79013 3.87632 10.2169C4.24347 10.6437 4.75728 10.9174 5.31632 10.9839L5.45799 10.9964L6.66632 11.063V6.43635ZM15.833 8.33302V9.99969C16.0454 9.99945 16.2497 9.91812 16.4041 9.77231C16.5586 9.62651 16.6515 9.42723 16.664 9.21519C16.6764 9.00316 16.6074 8.79437 16.4711 8.63149C16.3348 8.46862 16.1414 8.36394 15.9305 8.33885L15.833 8.33302Z",
				fill: "#F2F2F7"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5583_50499",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAnnounce);
export default ForwardRef;
